import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
	AlertMessage,
	AuthStatusStage,
	InlineAlertMessage,
	Navigation,
} from '@quizzach/components';
import {
	AuthPage,
	AuthResetEmailField,
	AuthStatus,
	BtnTeal,
} from '@quizzach/styles';
import { IcCheck } from '@quizzach/assets';
import { useResetPasswordStep1 } from '@quizzach/api-hooks';
import { ApiFailedReason, RoutePath } from '@quizzach/interfaces';
import { scrollToTop } from '@quizzach/utils';

export const ResetPasswordStep1 = () => {
	const {
		state,
		error,
		resetStep,
		buttonClicked,
		validationErrorState,
		handleInputChange,
		onSubmit,
	} = useResetPasswordStep1();

	const navigate = useNavigate();
	const { t } = useTranslation();

	useEffect(() => {
		scrollToTop();
	}, []);

	return (
		<AuthPage data-id='reset-password-container'>
			<Navigation />

			<AuthStatus>
				<AuthStatusStage
					hand={t(
						resetStep === 'reset_success'
							? 'auth.status.mailSent.hand'
							: 'auth.status.forgot.hand'
					)}
					title={t(
						resetStep === 'reset_success'
							? 'auth.resetPassword.step1.successTitle'
							: 'auth.resetPassword.step1.title'
					)}
				/>

				<div className='formcol'>
					<div className='inner'>
						{resetStep === 'reset_requesting' && (
							<>
								<p>{t('auth.resetPassword.step1.info')}</p>
								<form onSubmit={onSubmit}>
									<AuthResetEmailField>
										<input
											placeholder={t('auth.fields.email')}
											type={'text'}
											name={'email'}
											key={'email'}
											value={state['email']}
											onChange={handleInputChange}
										/>
									</AuthResetEmailField>

									{buttonClicked && validationErrorState && (
										<InlineAlertMessage
											message={validationErrorState}
											type='warning'
											className='validation-alert'
										/>
									)}

									{error && (
										<AlertMessage
											type='error'
											$fixed
											code={ApiFailedReason.default}
											style={{ width: '100%', marginBottom: '14px' }}
										/>
									)}

									<div style={{ marginTop: '18px' }}>
										<BtnTeal type='submit'>
											{t('auth.resetPassword.submit')}
										</BtnTeal>
									</div>
								</form>
							</>
						)}

						{resetStep === 'reset_success' && (
							<div className='done'>
								<div className='okrow' style={{ marginBottom: '18px' }}>
									<span className='oktick'>
										<IcCheck size={20} />
									</span>
									<p>
										{t('auth.resetPassword.step1.successInfo', {
											email: state['email'],
										})}
									</p>
								</div>
								<p className='mut'>
									{t('auth.resetPassword.step1.checkSpam')}{' '}
									<a href='mailto:team@quizzach.com'>team@quizzach.com</a>.
								</p>
								<BtnTeal
									type='button'
									onClick={() => navigate(RoutePath.Homepage)}
								>
									{t('auth.resetPassword.step1.ok')}
								</BtnTeal>
							</div>
						)}
					</div>
				</div>
			</AuthStatus>
		</AuthPage>
	);
};
